export default "<div class=\"l-faq-sec\">\n\t<breadcrumb currentPage=\"FAQ\"></breadcrumb>\n\t<faq-view></faq-view>\n</div>\n"